export default __webpack_public_path__ + "static/media/arrow.75e7526d.svg";